import { Component, OnInit, Inject } from "@angular/core";
import {
  FormControl,
  FormGroup,
  Validators,
  ValidatorFn,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { IntegrationSettingsService } from "../../integration-settings/integration-settings.service";
import { ToastrTranslatedService } from "../toastr-translated.service";
import { NotifyAdminDialogData } from "./notify-admin-dialog.interface";
import { ShowOnSubmitAttemptErrorStateMatcher } from "../error-state-matcher";

@Component({
  selector: "app-notify-admin-dialog",
  templateUrl: "./notify-admin-dialog.component.html",
  styleUrls: ["./notify-admin-dialog.component.scss"],
  standalone: false,
})
export class NotifyAdminDialogComponent implements OnInit {
  public sendingRequest = false;
  public form: FormGroup;
  public messageText = "";
  public subjectText = "";
  public provider: "google" | "microsoft";
  public errorStateMatcher = new ShowOnSubmitAttemptErrorStateMatcher();

  constructor(
    private service: IntegrationSettingsService,
    private translate: TranslateService,
    private toastr: ToastrTranslatedService,
    public dialogRef: MatDialogRef<NotifyAdminDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: NotifyAdminDialogData,
  ) {
    this.provider = data.provider;
    this.fillInitialForm();
  }

  ngOnInit(): void {
    this.loadMessageText();
  }

  fillInitialForm = () => {
    const requiredValidator: ValidatorFn = Validators.required.bind(
      null,
    ) as ValidatorFn;
    const emailValidator: ValidatorFn = Validators.email.bind(
      null,
    ) as ValidatorFn;
    this.form = new FormGroup({
      adminEmail: new FormControl("", [requiredValidator, emailValidator]),
      subject: new FormControl("", [requiredValidator]),
      message: new FormControl("", [requiredValidator]),
    });
  };

  loadMessageText = () => {
    const translationKeys = [
      `settings.integration.${this.provider}.notifyAdminDialog.subject`,
      `settings.integration.${this.provider}.notifyAdminDialog.messageContent`,
    ];

    this.translate
      .get(translationKeys)
      .subscribe((translations: Record<string, string>) => {
        this.subjectText =
          translations[
            `settings.integration.${this.provider}.notifyAdminDialog.subject`
          ] || "";
        this.messageText =
          translations[
            `settings.integration.${this.provider}.notifyAdminDialog.messageContent`
          ] || "";
        this.form.patchValue({
          subject: this.subjectText,
          message: this.messageText,
        });
      });
  };

  submit = () => {
    this.errorStateMatcher.submitAttempted = true;
    if (this.form.invalid) {
      return;
    }
    this.sendingRequest = true;
    const formValue = this.form.value as {
      adminEmail: string;
      subject: string;
      message: string;
    };
    this.service
      .notifyAdmin(
        this.provider,
        formValue.adminEmail,
        formValue.subject,
        formValue.message,
      )
      .subscribe(
        () => {
          this.toastr.success(
            `settings.integration.${this.provider}.notifyAdminDialog.success`,
          );
          this.close(true);
        },
        () => {
          this.sendingRequest = false;
          this.toastr.error(
            `settings.integration.${this.provider}.notifyAdminDialog.error`,
          );
        },
      );
  };

  close = (response: boolean) => this.dialogRef.close(response);
}
